<div class="grid-container">
  <cdk-virtual-scroll-viewport itemSize="200" class="viewport">
    <ng-container *ngIf="cardLayout | async as layout">
      <div class="chart-grid" [style.grid-template-columns]="'repeat(' + (layout.columns / layout.chart.cols) + ', 1fr)'">
        <div class="chart-tile" [style.height.px]="layout.chart.rows * 200">
          <app-card>
            <cc-summary-chart class="summary-chart"></cc-summary-chart>
          </app-card>
        </div>
        <div class="chart-tile" [style.height.px]="layout.chart.rows * 200">
          <app-card>
            <cc-data-trend-chart class="data-trend-chart"></cc-data-trend-chart>
          </app-card>
        </div>
        <div class="chart-tile" [style.height.px]="layout.chart.rows * 200">
          <app-card>
            <cc-cleared-uncleared-chart class="cleared-uncleared-chart"></cc-cleared-uncleared-chart>
          </app-card>
        </div>
      </div>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>
